import annotationUtils from '@/utils/annotationUtils.js';
import storeHelpers from '@/utils/storeHelpers.js';
import analytics from "@/utils/analytics.js";
import bookUtils from '@/utils/bookUtils.js';
import serverUtils from '@/utils/serverUtils.js';

var zlib = require('zlib');
var Buffer = require('buffer').Buffer;
const Promise = require('bluebird');
const gunzip = Promise.promisify(zlib.gunzip);
const gzip = Promise.promisify(zlib.gzip);

const funcs = {
  loadPDF: async function(handle, book, metadata) {
    // calculate book URL
    var bookUrl = handle.$config.get('ecApi') + 'web/books/pdf/' + book._id;
    
    // check internet
    const isAvailable = await serverUtils.isEndpointAvailable(bookUrl);
    if (!isAvailable.status || isAvailable.code !== 200) {
      if (navigator.serviceWorker.controller.state !== "activated") {
        return {error: "The book you requested is not available, please check your internet connection"};
      }
    }

    // determine book password
    var pw = "";
    const id = metadata.bookID.replace(/\-/g, "").slice(-32);
    const token = metadata.token;

    for(let i = 0; i < token.length; i++)
      pw += (parseInt(id[i], 16) ^ parseInt(token[i], 16)).toString("16");

    return {bookUrl, pw};
  },
  getNewHighlightData(annotation, docViewer, page, currentColorIndex) {
    const x = annotation.getRect().x1;
    const y = annotation.getRect().y1;
    const width = annotation.getWidth();
    const height = annotation.getHeight();

    const xPercentage = (x / docViewer.getPageWidth(page)) * 10000.0; // 40,56
    const yPercentage = (1 - (y / docViewer.getPageHeight(page))) * 10000.0; // 52,72
    const widthPercentage = (width / docViewer.getPageWidth(page)) * 10000.0; // 35,32
    const heightPercentage = (height / docViewer.getPageHeight(page)) * 10000.0; // 2,00

    if (annotation.state === "new") {
      return [-1, -1, currentColorIndex, 3, xPercentage, yPercentage - heightPercentage + 7, widthPercentage, heightPercentage - 26];
    }
    return [-1, -1, currentColorIndex, 3, xPercentage, yPercentage - heightPercentage + 7, widthPercentage, heightPercentage];
  },
  collisionDetect(allHighlightAnnotationsOnPage, newHL, Annotations, anotationManager, multipleLine) {
    var highlightsExcludingChanged = allHighlightAnnotationsOnPage.filter(annot => annot !== newHL);
    var updatedHighlights = [];


    _.each(highlightsExcludingChanged, existingHL => {

      // if not the same y, then leave it unchanged and add to array
      if(!funcs.hlSameY(newHL, existingHL)) {
        updatedHighlights.push(existingHL);
      } else {
        //outer-overlap
        if(funcs.hlContains(newHL, existingHL)) {
          //do nothing - it doesn't get added back to the array
          anotationManager.deleteAnnotation(existingHL, false, false, false);
        }
        //inner-overlap
        else if (funcs.hlContains(existingHL, newHL)) {
          // split hl
          const leftHL = new Annotations.TextHighlightAnnotation();
          leftHL.PageNumber = existingHL.PageNumber;
          leftHL.StrokeColor = existingHL.StrokeColor;
          leftHL.Opacity = 0.6;
          var quads = {
            "x1": existingHL.getRect().x1,
            "x2": newHL.getRect().x1,
            "x3": newHL.getRect().x1,
            "x4": existingHL.getRect().x1,
            "y1": existingHL.getRect().y2,
            "y2": existingHL.getRect().y2,
            "y3": existingHL.getRect().y1,
            "y4": existingHL.getRect().y1
          }
          leftHL.Quads = [quads];
          leftHL.X = quads.x4;
          leftHL.Y = quads.y4;
          leftHL.Width = quads.x2 - quads.x1;
          leftHL.Height = quads.y1 - quads.y4;
          leftHL.Subject = "Highlight";

          const rightHL = new Annotations.TextHighlightAnnotation();
          rightHL.PageNumber = existingHL.PageNumber;
          rightHL.StrokeColor = existingHL.StrokeColor;
          rightHL.Opacity = 0.6;
          var quads = {
            "x1": newHL.getRect().x2,
            "x2": existingHL.getRect().x2,
            "x3": existingHL.getRect().x2,
            "x4": newHL.getRect().x2,
            "y1": existingHL.getRect().y2,
            "y2": existingHL.getRect().y2,
            "y3": existingHL.getRect().y1,
            "y4": existingHL.getRect().y1
          }
          rightHL.Quads = [quads];
          rightHL.X = quads.x4;
          rightHL.Y = quads.y4;
          rightHL.Width = quads.x2 - quads.x1;
          rightHL.Height = quads.y1 - quads.y4;
          rightHL.Subject = "Highlight";

          // if new hl is at the far left of the existing hl, dont add
          if (existingHL.getRect().x1 !== newHL.getRect().x1) {
            leftHL.state = "collisionStarted";
            updatedHighlights.push(leftHL);
          }

          // if new hl is at the far right of the existing hl, dont add
          if (existingHL.getRect().x2 !== newHL.getRect().x2) {
            rightHL.state = "collisionEnded";
            updatedHighlights.push(rightHL);
          }

          existingHL.state = "collisionStarted";
          anotationManager.deleteAnnotation(existingHL, false, false, false);
          anotationManager.addAnnotations([leftHL, rightHL], false, false);
          return;
        }

        //post-overlap
        else if (funcs.hlPreOverlap(existingHL, newHL)) {
          //remove right of existing heighlight
          const leftHL = new Annotations.TextHighlightAnnotation();
          leftHL.PageNumber = existingHL.PageNumber;
          leftHL.StrokeColor = existingHL.StrokeColor;
          leftHL.Opacity = 0.6;
          var quads = {
            "x1": existingHL.getRect().x1,
            "x2": newHL.getRect().x1,
            "x3": newHL.getRect().x1,
            "x4": existingHL.getRect().x1,
            "y1": existingHL.getRect().y2,
            "y2": existingHL.getRect().y2,
            "y3": existingHL.getRect().y1,
            "y4": existingHL.getRect().y1
          }
          leftHL.Quads = [quads];
          leftHL.X = quads.x4;
          leftHL.Y = quads.y4;
          leftHL.Width = quads.x2 - quads.x1;
          leftHL.Height = quads.y1 - quads.y4;
          leftHL.state = "collisionEnded";
          leftHL.Subject = "Highlight";
          
          updatedHighlights.push(leftHL);

          newHL.state = "collisionStarted";
          existingHL.state = "collisionStarted";
          anotationManager.deleteAnnotation(existingHL, false, false, false);
          anotationManager.addAnnotations([leftHL], false, false);
          return;
        }      

        //pre-overlap
        else if (funcs.hlPostOverlap(existingHL, newHL)) {
          //remove left of existing heighlight
          const rightHL = new Annotations.TextHighlightAnnotation();
          rightHL.PageNumber = existingHL.PageNumber;
          rightHL.StrokeColor = existingHL.StrokeColor;
          rightHL.Opacity = 0.6;
          var quads = {
            "x1": newHL.getRect().x2,
            "x2": existingHL.getRect().x2,
            "x3": existingHL.getRect().x2,
            "x4": newHL.getRect().x2,
            "y1": existingHL.getRect().y2,
            "y2": existingHL.getRect().y2,
            "y3": existingHL.getRect().y1,
            "y4": existingHL.getRect().y1
          }
          rightHL.Quads = [quads];
          rightHL.X = quads.x4;
          rightHL.Y = quads.y4;
          rightHL.Width = quads.x2 - quads.x1;
          rightHL.Height = quads.y1 - quads.y4;
          rightHL.state = "collisionEnded";
          rightHL.Subject = "Highlight";

          updatedHighlights.push(rightHL);

          newHL.state = "collisionStarted";
          existingHL.state = "collisionStarted";
          anotationManager.deleteAnnotation(existingHL, false, false, false);
          anotationManager.addAnnotations([rightHL], false, false);
          return;
        } else {
          updatedHighlights.push(existingHL);
        }
      }
    });

    // changed (if there was collisions, plus the changed one)
    if (multipleLine) {
      anotationManager.addAnnotations([newHL], false, false);
    }
    
    updatedHighlights.push(newHL);
    return updatedHighlights;
  },
  hlIntersects(hl1, hl2) {
    if(hl1.getRect().x1 > hl2.getRect().x2 || hl2.getRect().x1 > hl1.getRect().x2) return false;
    return true;
  },
  hlContains(hl1, hl2) {
    if(hl1.getRect().x1 <= hl2.getRect().x1 && hl1.getRect().x2 >= hl2.getRect().x2) return true;
    return false;
  },
  hlPreOverlap(hl1, hl2) {
    if (hl1.getRect().x1 < hl2.getRect().x1 && hl1.getRect().x2 > hl2.getRect().x1) return true;
    return false;
  },
  hlPostOverlap(hl1, hl2) {
    if (hl1.getRect().x1 < hl2.getRect().x2 && hl1.getRect().x2 > hl2.getRect().x2) return true;
    return false;
  },
  hlSameY(hl1, hl2) {
    if(Math.abs(hl1.getRect().y1 - hl2.getRect().y1) > 5) return false; // give a leeway of 5px
    if(Math.abs(hl1.getRect().y2 - hl2.getRect().y2) > 5) return false; // give a leeway of 5px
    return true;
  },
  updateHL(handle, highlights, hlData, page, bookId) {
    // existing hl
    if(highlights[page]) {
      highlights[page].content = hlData;
      // highlight: function(handle, hlId, bookId, section)
    } else {
      // new hl
      highlights[page] = {
        content: hlData,
        book: bookId,
        section: page,
        version: 1000,
        selector: "",
        hash: bookUtils.constructHLId(page, bookId)
      };

      // add it to the store temporarily (until next sync)
      storeHelpers.addHighlight(handle, highlights[page])
      // highlight: function(handle, hlId, bookId, section)
    }

    analytics.highlight(handle, highlights[page]._id, bookId, highlights[page].section);

    const hlWithNoObservers = JSON.parse(JSON.stringify(highlights[page]));
    var contentDecimalArray = [];

    _.each(hlWithNoObservers.content, hl => {
      var hlDecimal = hl.slice(0);
      hlDecimal[4] = hlDecimal[4] / 100.0;
      hlDecimal[5] = hlDecimal[5] / 100.0;
      hlDecimal[6] = hlDecimal[6] / 100.0;
      hlDecimal[7] = hlDecimal[7] / 100.0;

      hl[4] = Math.round(hl[4]);
      hl[5] = Math.round(hl[5]);
      hl[6] = Math.round(hl[6]);
      hl[7] = Math.round(hl[7]);

      contentDecimalArray.push(hlDecimal);
    })

    storeHelpers.addItemToSync(handle, {
      url: handle.$config.get('ecApi') + "highlights2", 
      method: "post",
      data: {
        book: hlWithNoObservers.book,
        section: hlWithNoObservers.section,
        hash: hlWithNoObservers.hash,
        content: hlWithNoObservers.content,
        contentDecimal: contentDecimalArray
      }
    });
  },
  getRectFromHLData(hlData, docViewer, pageOneBased) {
    // between 0 and 1
    const xPercentage = hlData[4] / 10000.00;
    const yPercentage = hlData[5] / 10000.00;
    const widthPercentage = hlData[6] / 10000.00;
    const heightPercentage = hlData[7] / 10000.00;

    const y = docViewer.getPageHeight(pageOneBased - 1) - (docViewer.getPageHeight(pageOneBased - 1) * yPercentage);
    const x = docViewer.getPageWidth(pageOneBased - 1) * xPercentage;
    const width = docViewer.getPageWidth(pageOneBased - 1) * widthPercentage;
    const height = docViewer.getPageHeight(pageOneBased - 1) * heightPercentage;

    return {x, y, width, height};
  },
  hlDataToAnnotation(pageOneBased, hlData, docViewer, Annotations) {
    const colorIndex = hlData[2];
    // const type = hlData[3];

    const {x, y, width, height} = funcs.getRectFromHLData(hlData, docViewer, pageOneBased);

    var highlight = new Annotations.TextHighlightAnnotation();
    highlight.PageNumber = pageOneBased;
    highlight.X = x;
    highlight.Y = y - height;
    highlight.Width = width;
    highlight.Height = height;
    highlight.imported = true;
    highlight.Quads = [
      {
        "x1": highlight.X,
        "y1": highlight.Y,
        "x2": highlight.X + highlight.Width,
        "y2": highlight.Y,
        "x3": highlight.X + highlight.Width,
        "y3": highlight.Y + highlight.Height,
        "x4": highlight.X,
        "y4": highlight.Y + highlight.Height
      }
    ];
    var RGBColors = funcs.hexToRGB(annotationUtils.hlIndexToColor(colorIndex))
    highlight.Opacity = 0.6;
    highlight.StrokeColor = new Annotations.Color(RGBColors[0], RGBColors[1], RGBColors[2], highlight.Opacity);

    return highlight;
  },
  hexToRGB: function (hex) {
    return hex.replace(/^#?([a-f\d])([a-f\d])([a-f\d])$/i, (m, r, g, b) => '#' + r + r + g + g + b + b)
      .substring(1).match(/.{2}/g)
      .map(x => parseInt(x, 16))
  },
  getDrawingAttResAndObject: async function(page, drawings) {
    // look for existing drawing resource and attachment
    var drawingAttForPage = _.find(drawings.attachments, att => att.section === page.toString());
    var drawingResForPage;
    var drawingObject;

    if(drawingAttForPage) {
      drawingResForPage = drawings.resourcesById[drawingAttForPage.resource];
    }

    // get drawing object if there is an existing resource
    if(drawingResForPage) {
      drawingObject = await funcs.getDrawingObject(drawingResForPage);
    }

    return {
      drawingObject,
      drawingResForPage,
      drawingAttForPage
    }
  },
  getDrawingObject: async function(res) {
    const Drawing = window.appDataProtobuf.lookupType("Drawing");
    const packedData = Buffer.from(res.packed, "base64");

    try {
      const gunzippedData = await gunzip(packedData);
      const drawingObject = Drawing.decode(gunzippedData);
      return drawingObject;
    } catch (err) {
    }
  },
  freehandAnnotationFromProtosSegment(page, segment, docViewer, Annotations, canvasWidth, canvasHeight) {
    var freehand = new Annotations.FreeHandAnnotation();
    freehand.PageNumber = page;
    freehand.Opacity = 0.6;
    var RGBColors = funcs.hexToRGB(annotationUtils.hlIndexToColor(segment.colour))
    freehand.StrokeColor = new Annotations.Color(RGBColors[0], RGBColors[1], RGBColors[2], freehand.Opacity);
    freehand.StrokeThickness = segment.width;
    freehand.imported = true;

    _.each(segment.points, point => {
      const x = (point.xDec/canvasWidth) * docViewer.getPageWidth(page-1);
      const y = ((canvasHeight - point.yDec)/canvasHeight) * docViewer.getPageHeight(page-1);
    
      freehand.addPathPoint(x, y);
    });

    return freehand;
  },
  updateDrawing: async function(handle, freehandsForThisPage, docViewer, page, drawings, action) {
    const newCanvasSize = funcs.getCanvasSize(docViewer, page);

    var {
      drawingObject,
      drawingAttForPage,
      drawingResForPage
    } = await funcs.getDrawingAttResAndObject(page, drawings);

    if (!drawingObject || !drawingAttForPage || !drawingResForPage) {
      return; // this shouldn't happen, just checking for safety
    }

    drawingObject.canvasSize = newCanvasSize;
    drawingObject.segments = [];


    _.each(freehandsForThisPage, annotation => {
      const paths = annotation.getPaths();
      _.each(paths, path => {
        // create a new segment
        var newSegment = {
          colour: annotationUtils.colorToHlIndex(annotation.StrokeColor.R, annotation.StrokeColor.G, annotation.StrokeColor.B), 
          width: Math.round(annotation.StrokeThickness),
          points: [],
          // source: 0, // miEbooks
          // type: 0 // Freehand
        };

        _.each(path, point => {
          const {x, y} = point;
          newSegment.points.push({
            x: parseInt(x),
            xDec: x,
            y: parseInt(drawingObject.canvasSize.y - y),
            yDec: drawingObject.canvasSize.y - y
          });
        });

        drawingObject.segments.push(newSegment);
      });
    });
    await funcs.saveDrawing(handle, drawingObject, drawingResForPage, drawingAttForPage, drawingAttForPage.book, page, false);
  },
  getCanvasSize(docViewer, page) {
    return {
      x: parseInt(docViewer.getPageWidth(page)),
      xDec: docViewer.getPageWidth(page),
      y: parseInt(docViewer.getPageHeight(page)),
      yDec: docViewer.getPageHeight(page)
    };
  },
  addSegmentToDrawing: async function (handle, annotation, bookId, drawings, docViewer, hlPenSettings, action, freehandsForThisPage) {
    const page = annotation.PageNumber;
    const newCanvasSize = funcs.getCanvasSize(docViewer, page);

    var {
      drawingObject,
      drawingAttForPage,
      drawingResForPage
    } = await funcs.getDrawingAttResAndObject(page, drawings);
    
    if (!drawingObject) {
      drawingObject = {
        segments: []
      }
    } else if(drawingObject.segments.length > 0) {
      // if old canvas size differ with new, convert them
      if(drawingObject.canvasSize.x !== newCanvasSize.x || drawingObject.canvasSize.y !== newCanvasSize.y) {
        _.each(drawingObject.segments, segment => {
          _.each(segment.points, point => {
            const x = (point.xDec/drawingObject.canvasSize.xDec) * newCanvasSize.xDec;
            const y = (point.yDec/drawingObject.canvasSize.yDec) * newCanvasSize.yDec;

            point.x = parseInt(x);
            point.xDec = x;
            point.y = parseInt(y);
            point.yDec = y;
          });
        });
      }
    }

    drawingObject.version = 2;

    // update canvas size
    drawingObject.canvasSize = newCanvasSize;

    const paths = annotation.getPaths();
    _.each(paths, path => {
      // create a new segment
      var newSegment = {
        colour: hlPenSettings.penColor,
        width: hlPenSettings.lineThickness,
        points: [],
        // source: 0, // miEbooks
        // type: 0 // Freehand
      };
      
      _.each(path, point => {
        const {x, y} = point;
        newSegment.points.push({
          x: parseInt(x),
          xDec: x,
          y: parseInt(drawingObject.canvasSize.y - y),
          yDec: drawingObject.canvasSize.y - y
        });
      });

      drawingObject.segments.push(newSegment);
    });

    await funcs.saveDrawing(handle, drawingObject, drawingResForPage, drawingAttForPage, bookId, page, false)
  },
  saveDrawing: async function(handle, drawingObject, drawingResForPage, drawingAttForPage, bookId, page, isUndoRedo) {
    // convert it to base64(gzip(Protobuf))
    const Drawing = window.appDataProtobuf.lookupType("Drawing");
    const buffer = await gzip(Drawing.encode(drawingObject).finish());
    const newData = buffer.toString("base64");

    var errMsg = Drawing.verify(drawingObject);

    if(errMsg) {
      console.error(errMsg);
    }

    var isNewDrawing = false;
    
    // new drawing resource
    if(!drawingResForPage) {
      isNewDrawing = isUndoRedo ? false : true;
      
      const newResourceId = "drawing-annotation-" + bookId + "-" + page;
      drawingResForPage = {
        id: newResourceId,
        _id: newResourceId,
        category: "drawing",
        base64text: null,
        packed: newData,
        title: "Drawing",
        type: "wmgc.mobi.content.resources.DrawingAnnotation"
      }

      storeHelpers.addResource(handle, drawingResForPage);
    }

    // new drawing attachment
    if(!drawingAttForPage) {
      const newAttachmentId = "attachment-" + bookId + "-" + page;
      drawingAttForPage = {
        id: newAttachmentId,
        _id: newAttachmentId,
        book: bookId,
        resource: drawingResForPage.id,
        resourceObj: drawingResForPage,
        section: page.toString(),
        selector: "0.0",
        type: "wmgc.mobi.content.resources.CssSelectorAttachment"
      };

      storeHelpers.addAttachment(handle, drawingAttForPage);
    }

    drawingResForPage.packed = newData;

    const attCopy = Object.assign({}, drawingAttForPage);
    delete attCopy["resourceObj"];

    funcs.addDrawingToSync(handle, isNewDrawing, drawingResForPage, drawingAttForPage, attCopy);
  },
  addDrawingToSync: function (handle, isNewDrawing, drawingResForPage, drawingAttForPage, attCopy) {
    var urlObj = handle.$config.get('ecApi') + "annotations/" + (isNewDrawing ? "" : drawingResForPage._id);
    var methodObj = isNewDrawing ? "post" : "put";
    var dataObj = {
      "book": drawingAttForPage.book,
      "formatversion": 2,
      "id": drawingResForPage._id,
      "data": JSON.stringify({
        "id": drawingResForPage._id,
        "type": "wmgc.mobi.content.resources.DrawingAnnotation",
        "attachments": [
          attCopy
        ],
        "title": drawingResForPage.title,
        "base64text": drawingResForPage.base64text,
        "packed": drawingResForPage.packed
      })
    }
    storeHelpers.addItemToSync(handle, {
      url: urlObj,
      method: methodObj,
      data: dataObj
    });
  }
}

export default funcs